import { openDB } from "idb";

const DB_NAME = "orecantiere";
const DB_VERSION = 1;

let dbPromise = null;
function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        // Cache for GET responses, keyed by URL+search
        if (!db.objectStoreNames.contains("cache")) {
          db.createObjectStore("cache");
        }
        // Pending writes queue
        if (!db.objectStoreNames.contains("queue")) {
          const store = db.createObjectStore("queue", {
            keyPath: "id",
            autoIncrement: true,
          });
          store.createIndex("by_created_at", "created_at");
        }
      },
    });
  }
  return dbPromise;
}

export async function cacheGet(key) {
  try {
    const db = await getDb();
    return await db.get("cache", key);
  } catch {
    return null;
  }
}
export async function cacheSet(key, value) {
  try {
    const db = await getDb();
    await db.put("cache", value, key);
  } catch (err) {
    console.warn("[offlineDb] cacheSet fallito:", err?.message);
  }
}

export async function queueAdd(item) {
  const db = await getDb();
  const id = await db.add("queue", { ...item, created_at: Date.now() });
  return id;
}
export async function queueGetAll() {
  const db = await getDb();
  return db.getAllFromIndex("queue", "by_created_at");
}
export async function queueDelete(id) {
  const db = await getDb();
  await db.delete("queue", id);
}
export async function queueCount() {
  const db = await getDb();
  return db.count("queue");
}
